/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchGroupWithNetAmount } from './BranchGroupWithNetAmount';
import {
    BranchGroupWithNetAmountFromJSON,
    BranchGroupWithNetAmountFromJSONTyped,
    BranchGroupWithNetAmountToJSON,
    BranchGroupWithNetAmountToJSONTyped,
} from './BranchGroupWithNetAmount';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithNetAmountPerPaymentMethodResponse
 */
export interface BusinessReportBranchesWithNetAmountPerPaymentMethodResponse {
    /**
     * 
     * @type {Array<BranchGroupWithNetAmount>}
     * @memberof BusinessReportBranchesWithNetAmountPerPaymentMethodResponse
     */
    data: Array<BranchGroupWithNetAmount>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithNetAmountPerPaymentMethodResponse interface.
 */
export function instanceOfBusinessReportBranchesWithNetAmountPerPaymentMethodResponse(value: object): value is BusinessReportBranchesWithNetAmountPerPaymentMethodResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithNetAmountPerPaymentMethodResponseFromJSON(json: any): BusinessReportBranchesWithNetAmountPerPaymentMethodResponse {
    return BusinessReportBranchesWithNetAmountPerPaymentMethodResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetAmountPerPaymentMethodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithNetAmountPerPaymentMethodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchGroupWithNetAmountFromJSON)),
    };
}

export function BusinessReportBranchesWithNetAmountPerPaymentMethodResponseToJSON(json: any): BusinessReportBranchesWithNetAmountPerPaymentMethodResponse {
    return BusinessReportBranchesWithNetAmountPerPaymentMethodResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetAmountPerPaymentMethodResponseToJSONTyped(value?: BusinessReportBranchesWithNetAmountPerPaymentMethodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchGroupWithNetAmountToJSON)),
    };
}

